﻿export * from './resultado.component';
